import { channelPartnerWebhookQueryKeys as e } from "./useChannelPartnerWebhookQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminChannelPartnerWebhooksApi as n } from "@maat/api-main";
//#region src/channelPartnerWebhooks/useChannelPartnerDeliveriesQuery.ts
var r = 50, i = (i = {}, a = !0) => t({
	queryKey: e.deliveries(i),
	fetchPage: (e) => n.listDeliveries({
		...i,
		page: e,
		pageSize: r
	}),
	key: "items",
	enabled: a
});
//#endregion
export { i as useChannelPartnerDeliveriesQuery };
